export function toggleHas<T>(set: Set<T>, value: T) {
  if (set.has(value)) {
    set.delete(value)
  } else {
    set.add(value)
  }
}

export const statefulToggleHas =
  <T>(element: T, setState: React.Dispatch<React.SetStateAction<Set<T>>>) =>
    setState((selectedElements) => {
      const newSelections = new Set([...selectedElements])
      toggleHas(newSelections, element)
      return newSelections
    })

export const addToNewSet = <T>(selectedSet: Set<T>, value?: T | Array<T>): Set<T> => {
  if (!value) {
    return selectedSet
  }
  const newSet = new Set([...selectedSet])
  if (Array.isArray(value)) {
    value.forEach((val) => {
      newSet.add(val)
    })
  } else {
    newSet.add(value)
  }
  return newSet
}
